import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { CampaignAdapter } from 'src/adapters/campaign-adapter';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { ObjectType } from "../data/constants/object-type.enum";
import { StorageService } from 'src/app/services/storage.service';
import { MessageService } from "./message.service";
import { CampaignVO } from './../data/vo/CampaignVO';

const CUSTOMER_ID = 'CUSTOMER_ID';
const BRAND_ID = 'BRAND_ID';
const ADVERTISER_ID = 'ADVERTISER_ID';

@Injectable()
export class CampaignDataResolver implements Resolve<any> {

    constructor(private campaignAdapter: CampaignAdapter,
        private creativeAdapter: CreativeAdapter,
        private localStore: StorageService,
        private router: Router) { }

    resolve(route: ActivatedRouteSnapshot) {

        let returnData = [],
            campaignId = parseInt(route.paramMap.get('campaignId')),
            allPromise = [],
            campaignDataPromise: Promise<CampaignVO>;
        return new Promise((resolve) => {
            this.campaignAdapter.isMultiAdvertiser().then((isMultiAdvertiser: boolean) => {
                if (campaignId) {
                    campaignDataPromise = this.campaignAdapter.fetchAllCampaignData(campaignId);
                } else {
                    campaignDataPromise = this.campaignAdapter.createPlanAndCampaign();
                }
                campaignDataPromise.then((data: CampaignVO) => {
                    returnData.push(data);
                    if (isMultiAdvertiser) {
                        if (campaignId) {
                            this.campaignAdapter.getPlan(data.planId).then((resp) => {
                                this.campaignAdapter.updateCBAId(resp.customer_id, resp.advertiser_id, resp.brand_id);
                                allPromise.push(
                                    this.creativeAdapter.getCreativeByCampaignId(campaignId),
                                    this.campaignAdapter.getCampaignOrder(campaignId),
                                    this.campaignAdapter.getAllRejectedCreative(campaignId)
                                )
                                Promise.all(allPromise).then((allPromiseData) => {
                                    returnData.push(...allPromiseData);
                                    resolve(returnData);
                                })
                            });
                        } else {
                            if (!this.localStore.getItem(CUSTOMER_ID, 'session')) {
                                this.router.navigate(['company']);
                            } else if (!this.localStore.getItem(ADVERTISER_ID, 'session')) {
                                // redirect to all advertiser page
                                this.router.navigate(['advertiser/brand-list']);
                            } else if (!this.localStore.getItem(BRAND_ID, 'session')) {
                                // redirect to single advertiser page
                                this.router.navigate(['advertiser/campaign-list']);
                            } else {
                                resolve(returnData);
                            }
                        }
                    } else {
                        if (campaignId) {
                            allPromise.push(
                                this.creativeAdapter.getCreativeByCampaignId(campaignId),
                                this.campaignAdapter.getCampaignOrder(campaignId),
                                this.campaignAdapter.getAllRejectedCreative(campaignId)
                            )
                            Promise.all(allPromise).then((allPromiseData) => {
                                returnData.push(...allPromiseData);
                                resolve(returnData);
                            })
                        } else {
                            resolve(returnData);
                        }
                    }
                });
            });
        });
    }
}

@Injectable()
export class ListDataResolver implements Resolve<any> {

    constructor(private campaignAdapter: CampaignAdapter, private router: Router, private messageService: MessageService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let getCBAIdAndRedirect = (checkCustomer: boolean, checkAdvertiser: boolean, checkBrand: boolean) => {
            return this.campaignAdapter.getCBAId().then(v => {
                // always check customer id
                if (checkCustomer && !v.customerId) {
                    // redirect to all company list page
                    this.router.navigate(['company/list']).catch((e) => {
                        console.error(e);
                    });
                } else if (checkAdvertiser && !v.advertiserId) {
                    // redirect to all advertiser list page
                    this.router.navigate(['advertiser/brand-list']).catch((e) => {
                        console.error(e);
                    });
                } else if (checkBrand && !v.brandId) {
                    // redirect to single advertiser list page
                    this.router.navigate(['advertiser/campaign-list']).catch((e) => {
                        console.error(e);
                    });
                }
                // There will be a chance when redirect from non-list page to list page, remove the form title content
                this.messageService.sendFormTitle([null, null, null]);
                return v;
            });
        };

        if (route.data.objectType === ObjectType.Campaign || route.data.objectType === ObjectType.Creative) {
            return this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
                return getCBAIdAndRedirect(true, true, true);
            }));
        } else if (route.data.objectType === ObjectType.Advertiser) {
            return this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
                if (!isMultiAdvertiser) {
                    // redirect to campaign dashboard
                    this.router.navigate(['campaign/list']);
                } else {
                    // check advertiser if it is single advertiser list
                    return getCBAIdAndRedirect(true, route.url[0].path === 'campaign-list', false);
                }
            }));
        } else if (route.data.objectType === ObjectType.Company) {
            return this.campaignAdapter.isMultiAdvertiser().then(((isMultiAdvertiser: boolean) => {
                if (!isMultiAdvertiser) {
                    // redirect to campaign dashboard
                    this.router.navigate(['campaign/list']);
                } else {
                    return getCBAIdAndRedirect(route.url[0].path === 'advertiser-list', false, false);
                }
            }));
        }
    }
}

